<template>
  <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.code"
            :external-errors="errors['code']"
            :label-form="'Code' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="text"
            :value="form.code"
            :disabled="!formEditable || id"
            @change="$set(form, 'code', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="$set(form, 'name', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-select
            :validator="$v.form.type"
            :external-errors="errors['type']"
            :label-form="'Type' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            label-search="text"
            :disabled="!formEditable"
            :value="form.type ? { value: form.type, text: form.type_name } : null"
            :placeholder="$t('Select an option')"
            :options="macroTypeListOptions"
            @select="selectMacroType"
            @clear="clearMacroType"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
        <b-button
          class="mr-3"
          variant="default"
          @click.prevent="formEditable ? cancel() : closeForm()">
          {{ formEditable ? 'Cancel' : 'Close' | translate }}
        </b-button>
        <b-button
          variant="primary"
          v-has-perms="editRolePerm"
          @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
          :disabled="$v.form.$invalid">
          {{ formEditable ? 'Save' : 'Edit' | translate }}
        </b-button>
      </div>
    </div>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { TYPES as TASK_CATEGORY_TYPES } from './store'

import ThuxDetailPanelMixin from '../../../components/thux-detail-panel/ThuxDetailPanelMixin'
import MacroTypeMixin from './mixins/MacroTypeMixin'

export default {
  name: 'TaskCategoryEdit',
  mixins: [ThuxDetailPanelMixin, MacroTypeMixin],
  data () {
    return {
      pageName: 'Category',
      rolePerm: 'tasks_taskcategory_retrieve',
      editRolePerm: 'tasks_taskcategory_update'
    }
  },
  computed: {
    ...mapGetters({
      ...TASK_CATEGORY_TYPES.GENERIC.task['task-category'].DETAIL.GETTERS
    })
  },
  components: { },
  methods: {
    ...mapActions({
      ...TASK_CATEGORY_TYPES.GENERIC.task['task-category'].DETAIL.ACTIONS
    }),
    getFormData () {
      return Object.assign({}, this.form)
    }
  },
  validations: {
    form: {
      code: { required },
      name: { required },
      type: { required }
    }
  }
}
</script>
